import { Badge } from '@/components/ui/badge';
import type { Role } from '@/lib/auth-store';
import { ROLE_LABEL } from '@/lib/roles';

export function RoleBadge({ role }: { role: Role }) {
  return <Badge variant="secondary">{ROLE_LABEL[role]}</Badge>;
}
